import { type PolymorphicComponent } from '@mui/base'
import { clsx } from 'clsx'
import { type ElementType, type ReactNode } from 'react'

import { Skeleton } from 'base-ui'

import { useRecommendationWidgetContext } from '../RecommendationAreaProvider'

type RecommendationHorizontalSliderAreaTitleOwnProps = {
  children?: ReactNode
  className?: string
  slots?: {
    root?: ElementType
  }
}

interface RecommendationHorizontalSliderAreaTitleTypeMap<
  RootComponentType extends ElementType = 'h2',
> {
  defaultComponent: RootComponentType
  props: RecommendationHorizontalSliderAreaTitleOwnProps
}

export const RecommendationWidgetTitle: PolymorphicComponent<
  RecommendationHorizontalSliderAreaTitleTypeMap
> = ({ children, className, slots, ...restProps }) => {
  const { widgetTitle } = useRecommendationWidgetContext()
  const Root = slots?.root ?? 'h2'
  const title = widgetTitle ?? children

  if (!title) {
    return (
      <Skeleton
        {...restProps}
        className={clsx('recommendations-area-title_skeleton', className)}
      />
    )
  }

  return (
    <Root {...restProps} className={className}>
      {title}
    </Root>
  )
}
